import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#999",
      "fill-rule": "nonzero",
      d: "M7 10.492c-2.565 0-4.853-1.619-6.86-4.78a.87.87 0 0 1 0-.932C2.148 1.62 4.436 0 7 0s4.853 1.619 6.859 4.78c.18.284.18.647 0 .931-2.006 3.162-4.294 4.78-6.86 4.78m0-9.443c-2.123 0-4.09 1.375-5.904 4.197C2.91 8.068 4.876 9.442 7 9.442s4.09-1.374 5.903-4.196C11.09 2.424 9.123 1.049 7 1.049m0 6.645a2.46 2.46 0 0 1-2.47-2.448A2.46 2.46 0 0 1 7 2.798a2.46 2.46 0 0 1 2.47 2.448A2.46 2.46 0 0 1 7 7.694m0-1.05c.78 0 1.411-.626 1.411-1.398 0-.773-.632-1.4-1.411-1.4-.78 0-1.412.627-1.412 1.4S6.22 6.645 7 6.645"
    }, null, -1)
  ])))
}
export default { render: render }